"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6472],{

/***/ 65509:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ FactoryCookie; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90581);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50853);
/* harmony import */ var _kernel_Environment__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24880);




var FactoryCookie = /*#__PURE__*/ function() {
    "use strict";
    function FactoryCookie(config) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, FactoryCookie);
        this.config = config;
    }
    var _proto = FactoryCookie.prototype;
    _proto.cookie = function cookie() {
        var _this = this;
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
            var isNode, _tmp;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        isNode = _kernel_Environment__WEBPACK_IMPORTED_MODULE_3__/* .Environment.create */ .q.create().isNode();
                        if (!isNode) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            __webpack_require__.e(/* import() */ 5107).then(__webpack_require__.t.bind(__webpack_require__, 15107, 23))
                        ];
                    case 1:
                        _tmp = _state.sent().NodeCookie.create({
                            config: _this.config
                        });
                        return [
                            3,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            __webpack_require__.e(/* import() */ 9351).then(__webpack_require__.bind(__webpack_require__, 39351))
                        ];
                    case 3:
                        _tmp = _state.sent().WindowCookie.create({
                            config: _this.config
                        });
                        _state.label = 4;
                    case 4:
                        return [
                            2,
                            _tmp
                        ];
                }
            });
        })();
    };
    FactoryCookie.create = function create(param) {
        var config = param.config;
        return new FactoryCookie(config);
    };
    return FactoryCookie;
}();


/***/ }),

/***/ 78599:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ FactoryQueryParams; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90581);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50853);
/* harmony import */ var _kernel_Environment__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24880);




var FactoryQueryParams = /*#__PURE__*/ function() {
    "use strict";
    function FactoryQueryParams(config) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, FactoryQueryParams);
        this.config = config;
    }
    var _proto = FactoryQueryParams.prototype;
    _proto.params = function params() {
        var _this = this;
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
            var isNode, _tmp;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        isNode = _kernel_Environment__WEBPACK_IMPORTED_MODULE_3__/* .Environment.create */ .q.create().isNode();
                        if (!isNode) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            __webpack_require__.e(/* import() */ 536).then(__webpack_require__.t.bind(__webpack_require__, 30536, 23))
                        ];
                    case 1:
                        _tmp = _state.sent().NodeQueryParams.create({
                            config: _this.config
                        });
                        return [
                            3,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            __webpack_require__.e(/* import() */ 877).then(__webpack_require__.bind(__webpack_require__, 20877))
                        ];
                    case 3:
                        _tmp = _state.sent().WindowQueryParams.create({
                            config: _this.config
                        });
                        _state.label = 4;
                    case 4:
                        return [
                            2,
                            _tmp
                        ];
                }
            });
        })();
    };
    FactoryQueryParams.create = function create(param) {
        var config = param.config;
        return new FactoryQueryParams(config);
    };
    return FactoryQueryParams;
}();


/***/ }),

/***/ 13668:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ ForbiddenSharedRepository; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90581);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50853);
/* harmony import */ var _kernel_DomainError__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11455);
/* harmony import */ var _kernel_ErrorsCode__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65694);





var ForbiddenSharedRepository = /*#__PURE__*/ function() {
    "use strict";
    function ForbiddenSharedRepository(config) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, ForbiddenSharedRepository);
        this.config = config;
    }
    var _proto = ForbiddenSharedRepository.prototype;
    _proto.affiliate = function affiliate() {
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
                throw _kernel_DomainError__WEBPACK_IMPORTED_MODULE_0__/* .DomainError.withCodes */ .Z.withCodes(_kernel_ErrorsCode__WEBPACK_IMPORTED_MODULE_1__/* .ErrorsCode.FORBIDDEN_REPOSITORY_METHOD */ .v.FORBIDDEN_REPOSITORY_METHOD);
            });
        })();
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _proto.featureFlagByName = function featureFlagByName(param) {
        var _name = param.name;
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
                throw _kernel_DomainError__WEBPACK_IMPORTED_MODULE_0__/* .DomainError.withCodes */ .Z.withCodes(_kernel_ErrorsCode__WEBPACK_IMPORTED_MODULE_1__/* .ErrorsCode.FORBIDDEN_REPOSITORY_METHOD */ .v.FORBIDDEN_REPOSITORY_METHOD);
            });
        })();
    };
    _proto.language = function language() {
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
                throw _kernel_DomainError__WEBPACK_IMPORTED_MODULE_0__/* .DomainError.withCodes */ .Z.withCodes(_kernel_ErrorsCode__WEBPACK_IMPORTED_MODULE_1__/* .ErrorsCode.FORBIDDEN_REPOSITORY_METHOD */ .v.FORBIDDEN_REPOSITORY_METHOD);
            });
        })();
    };
    _proto.market = function market() {
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
                throw _kernel_DomainError__WEBPACK_IMPORTED_MODULE_0__/* .DomainError.withCodes */ .Z.withCodes(_kernel_ErrorsCode__WEBPACK_IMPORTED_MODULE_1__/* .ErrorsCode.FORBIDDEN_REPOSITORY_METHOD */ .v.FORBIDDEN_REPOSITORY_METHOD);
            });
        })();
    };
    _proto.operatingSystem = function operatingSystem() {
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
                throw _kernel_DomainError__WEBPACK_IMPORTED_MODULE_0__/* .DomainError.withCodes */ .Z.withCodes(_kernel_ErrorsCode__WEBPACK_IMPORTED_MODULE_1__/* .ErrorsCode.FORBIDDEN_REPOSITORY_METHOD */ .v.FORBIDDEN_REPOSITORY_METHOD);
            });
        })();
    };
    _proto.partialSearch = function partialSearch() {
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
                throw _kernel_DomainError__WEBPACK_IMPORTED_MODULE_0__/* .DomainError.withCodes */ .Z.withCodes(_kernel_ErrorsCode__WEBPACK_IMPORTED_MODULE_1__/* .ErrorsCode.FORBIDDEN_REPOSITORY_METHOD */ .v.FORBIDDEN_REPOSITORY_METHOD);
            });
        })();
    };
    _proto.platform = function platform() {
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
                throw _kernel_DomainError__WEBPACK_IMPORTED_MODULE_0__/* .DomainError.withCodes */ .Z.withCodes(_kernel_ErrorsCode__WEBPACK_IMPORTED_MODULE_1__/* .ErrorsCode.FORBIDDEN_REPOSITORY_METHOD */ .v.FORBIDDEN_REPOSITORY_METHOD);
            });
        })();
    };
    _proto.source = function source() {
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
                throw _kernel_DomainError__WEBPACK_IMPORTED_MODULE_0__/* .DomainError.withCodes */ .Z.withCodes(_kernel_ErrorsCode__WEBPACK_IMPORTED_MODULE_1__/* .ErrorsCode.FORBIDDEN_REPOSITORY_METHOD */ .v.FORBIDDEN_REPOSITORY_METHOD);
            });
        })();
    };
    ForbiddenSharedRepository.create = function create(param) {
        var config = param.config;
        return new ForbiddenSharedRepository(config);
    };
    return ForbiddenSharedRepository;
}();


/***/ }),

/***/ 86778:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "K": function() { return /* binding */ QueryParamSharedRepository; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(90581);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(64297);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(87394);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_create_super.mjs + 2 modules
var _create_super = __webpack_require__(39309);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(50853);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(27805);
// EXTERNAL MODULE: ../../node_modules/zod/v3/types.js + 1 modules
var types = __webpack_require__(53538);
// EXTERNAL MODULE: ../../packages/stayforlong/src/_kernel/architecture.ts
var architecture = __webpack_require__(70163);
;// CONCATENATED MODULE: ../../packages/stayforlong/src/shared/domain/Source.ts






var ALLOWED_SOURCES = [
    "web",
    "meta",
    "email"
];
var SourceValidation = types/* object */.Ry({
    value: types/* enum */.Km(ALLOWED_SOURCES, {
        required_error: "value is required"
    })
});
var Source = /*#__PURE__*/ function(Model) {
    "use strict";
    (0,_inherits/* default */.Z)(Source, Model);
    var _super = (0,_create_super/* default */.Z)(Source);
    function Source(_value) {
        (0,_class_call_check/* default */.Z)(this, Source);
        var _this;
        _this = _super.call(this);
        _this._value = _value;
        return _this;
    }
    var _proto = Source.prototype;
    _proto.isEmpty = function isEmpty() {
        return !this._value;
    };
    _proto.isFilled = function isFilled() {
        return !!this._value;
    };
    _proto.isDefault = function isDefault() {
        return this._value === Source.DEFAULT_SOURCE;
    };
    _proto.isNotDefault = function isNotDefault() {
        return this._value !== Source.DEFAULT_SOURCE;
    };
    _proto.toJSON = function toJSON() {
        var __value;
        return {
            value: (__value = this._value) !== null && __value !== void 0 ? __value : null
        };
    };
    Source.create = function create(param) {
        var value = param.value;
        SourceValidation.parse({
            value: value
        });
        return new Source(value);
    };
    Source.createOrEmpty = function createOrEmpty(param) {
        var value = param.value;
        try {
            return Source.create({
                value: value
            });
        } catch (e) {
            return Source.empty();
        }
    };
    Source.empty = function empty() {
        return new Source();
    };
    (0,_create_class/* default */.Z)(Source, [
        {
            key: "value",
            get: function get() {
                return this._value;
            }
        }
    ]);
    return Source;
}(architecture/* Model */.H);
Source.DEFAULT_SOURCE = "web";

// EXTERNAL MODULE: ../../packages/stayforlong/src/_queryparams/FactoryQueryParams.ts
var FactoryQueryParams = __webpack_require__(78599);
// EXTERNAL MODULE: ../../packages/stayforlong/src/shared/domain/Market.ts
var Market = __webpack_require__(14828);
// EXTERNAL MODULE: ../../packages/stayforlong/src/shared/domain/Language.ts
var Language = __webpack_require__(43491);
// EXTERNAL MODULE: ../../packages/stayforlong/src/_kernel/Date.ts
var _kernel_Date = __webpack_require__(83209);
// EXTERNAL MODULE: ../../packages/stayforlong/src/shared/domain/ListOfPax.ts + 1 modules
var ListOfPax = __webpack_require__(83760);
// EXTERNAL MODULE: ../../packages/stayforlong/src/shared/domain/PartialSearch.ts
var PartialSearch = __webpack_require__(60563);
// EXTERNAL MODULE: ../../packages/stayforlong/src/shared/infrastructure/ForbiddenSharedRepository.ts
var ForbiddenSharedRepository = __webpack_require__(13668);
;// CONCATENATED MODULE: ../../packages/stayforlong/src/shared/infrastructure/QueryParamSharedRepository.ts














var QueryParamSharedRepository = /*#__PURE__*/ function(ForbiddenSharedRepository) {
    "use strict";
    (0,_inherits/* default */.Z)(QueryParamSharedRepository, ForbiddenSharedRepository);
    var _super = (0,_create_super/* default */.Z)(QueryParamSharedRepository);
    function QueryParamSharedRepository(config) {
        (0,_class_call_check/* default */.Z)(this, QueryParamSharedRepository);
        return _super.call(this, config);
    }
    var _proto = QueryParamSharedRepository.prototype;
    _proto.market = function market() {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var params, ref, error, market;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            FactoryQueryParams/* FactoryQueryParams.create */.R.create({
                                config: _this.config
                            }).params()
                        ];
                    case 1:
                        params = _state.sent();
                        ref = (0,_sliced_to_array/* default */.Z)(params.getByQuery({
                            query: QueryParamSharedRepository.MARKET_QUERY_PARAMS
                        }), 2), error = ref[0], market = ref[1];
                        if (error) return [
                            2,
                            Market/* Market.empty */.IY.empty()
                        ];
                        return [
                            2,
                            Market/* Market.createOrEmpty */.IY.createOrEmpty({
                                value: market
                            })
                        ];
                }
            });
        })();
    };
    _proto.language = function language() {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var params, ref, error, language;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            FactoryQueryParams/* FactoryQueryParams.create */.R.create({
                                config: _this.config
                            }).params()
                        ];
                    case 1:
                        params = _state.sent();
                        ref = (0,_sliced_to_array/* default */.Z)(params.getByQuery({
                            query: QueryParamSharedRepository.QUERY_PARAM_LANGUAGE
                        }), 2), error = ref[0], language = ref[1];
                        if (error) return [
                            2,
                            Language/* Language.empty */.S.empty()
                        ];
                        return [
                            2,
                            Language/* Language.createOrEmpty */.S.createOrEmpty({
                                value: language
                            })
                        ];
                }
            });
        })();
    };
    _proto.partialSearch = function partialSearch() {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var params, ref, errorCheckIn, checkIn, ref1, errorCheckOut, checkOut, ref2, errorAdults, adults, ref3, errorChildren, children;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            FactoryQueryParams/* FactoryQueryParams.create */.R.create({
                                config: _this.config
                            }).params()
                        ];
                    case 1:
                        params = _state.sent();
                        ref = (0,_sliced_to_array/* default */.Z)(params.getByQuery({
                            query: "checkIn",
                            options: {
                                caseSensitive: false
                            }
                        }), 2), errorCheckIn = ref[0], checkIn = ref[1];
                        ref1 = (0,_sliced_to_array/* default */.Z)(params.getByQuery({
                            query: "checkOut",
                            options: {
                                caseSensitive: false
                            }
                        }), 2), errorCheckOut = ref1[0], checkOut = ref1[1];
                        ref2 = (0,_sliced_to_array/* default */.Z)(params.getByQuery({
                            query: "adults"
                        }), 2), errorAdults = ref2[0], adults = ref2[1];
                        ref3 = (0,_sliced_to_array/* default */.Z)(params.getByQuery({
                            query: "children",
                            options: {
                                required: false
                            }
                        }), 2), errorChildren = ref3[0], children = ref3[1];
                        if (errorCheckIn || errorCheckOut || errorAdults || errorChildren) {
                            return [
                                2,
                                PartialSearch/* PartialSearch.default */.u["default"]()
                            ];
                        }
                        return [
                            2,
                            PartialSearch/* PartialSearch.create */.u.create({
                                checkIn: _kernel_Date/* DateModel.create */.rV.create({
                                    value: checkIn
                                }),
                                checkOut: _kernel_Date/* DateModel.create */.rV.create({
                                    value: checkOut
                                }),
                                paxes: ListOfPax/* ListOfPax.fromQueryParams */.o.fromQueryParams({
                                    adults: adults,
                                    children: children
                                })
                            })
                        ];
                }
            });
        })();
    };
    _proto.source = function source() {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var params, ref, error, source;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            FactoryQueryParams/* FactoryQueryParams.create */.R.create({
                                config: _this.config
                            }).params()
                        ];
                    case 1:
                        params = _state.sent();
                        ref = (0,_sliced_to_array/* default */.Z)(params.getByQuery({
                            query: QueryParamSharedRepository.QUERY_PARAM_SOURCE
                        }), 2), error = ref[0], source = ref[1];
                        if (error) return [
                            2,
                            Source.empty()
                        ];
                        return [
                            2,
                            Source.createOrEmpty({
                                value: source
                            })
                        ];
                }
            });
        })();
    };
    QueryParamSharedRepository.create = function create(param) {
        var config = param.config;
        return new QueryParamSharedRepository(config);
    };
    return QueryParamSharedRepository;
}(ForbiddenSharedRepository/* ForbiddenSharedRepository */.H);
QueryParamSharedRepository.MARKET_QUERY_PARAMS = "market";
QueryParamSharedRepository.QUERY_PARAM_LANGUAGE = "lang";
QueryParamSharedRepository.QUERY_PARAM_SOURCE = "source";


/***/ }),

/***/ 76472:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "B": function() { return /* binding */ SharedRepositoryProxy; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(90581);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(64297);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_create_super.mjs + 2 modules
var _create_super = __webpack_require__(39309);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(50853);
// EXTERNAL MODULE: ../../packages/stayforlong/src/shared/domain/Language.ts
var Language = __webpack_require__(43491);
// EXTERNAL MODULE: ../../packages/stayforlong/src/shared/domain/Market.ts
var Market = __webpack_require__(14828);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(87394);
// EXTERNAL MODULE: ../../packages/stayforlong/src/_cookie/FactoryCookie.ts
var FactoryCookie = __webpack_require__(65509);
// EXTERNAL MODULE: ../../packages/stayforlong/src/_kernel/PriceType.ts
var PriceType = __webpack_require__(4962);
// EXTERNAL MODULE: ../../packages/stayforlong/src/shared/domain/Affiliate.ts
var Affiliate = __webpack_require__(54429);
// EXTERNAL MODULE: ../../packages/stayforlong/src/shared/infrastructure/ForbiddenSharedRepository.ts
var ForbiddenSharedRepository = __webpack_require__(13668);
;// CONCATENATED MODULE: ../../packages/stayforlong/src/shared/infrastructure/CookieSharedRepository.ts












var CookieSharedRepository = /*#__PURE__*/ function(ForbiddenSharedRepository) {
    "use strict";
    (0,_inherits/* default */.Z)(CookieSharedRepository, ForbiddenSharedRepository);
    var _super = (0,_create_super/* default */.Z)(CookieSharedRepository);
    function CookieSharedRepository(config) {
        (0,_class_call_check/* default */.Z)(this, CookieSharedRepository);
        return _super.call(this, config);
    }
    var _proto = CookieSharedRepository.prototype;
    _proto.market = function market() {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var cookie, ref, error, market;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            FactoryCookie/* FactoryCookie.create */.f.create({
                                config: _this.config
                            }).cookie()
                        ];
                    case 1:
                        cookie = _state.sent();
                        ref = (0,_sliced_to_array/* default */.Z)(cookie.get({
                            key: CookieSharedRepository.MARKET_COOKIE_NAME
                        }), 2), error = ref[0], market = ref[1];
                        if (error) return [
                            2,
                            Market/* Market.empty */.IY.empty()
                        ];
                        if (!market) return [
                            2,
                            Market/* Market.empty */.IY.empty()
                        ];
                        return [
                            2,
                            Market/* Market.create */.IY.create({
                                value: market
                            })
                        ];
                }
            });
        })();
    };
    _proto.language = function language() {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var cookie, ref, error, language;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            FactoryCookie/* FactoryCookie.create */.f.create({
                                config: _this.config
                            }).cookie()
                        ];
                    case 1:
                        cookie = _state.sent();
                        ref = (0,_sliced_to_array/* default */.Z)(cookie.get({
                            key: CookieSharedRepository.COOKIE_LANGUAGE
                        }), 2), error = ref[0], language = ref[1];
                        if (error) return [
                            2,
                            Language/* Language.empty */.S.empty()
                        ];
                        if (!language) return [
                            2,
                            Language/* Language.empty */.S.empty()
                        ];
                        return [
                            2,
                            Language/* Language.create */.S.create({
                                value: language
                            })
                        ];
                }
            });
        })();
    };
    _proto.affiliate = function affiliate() {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var cookie, ref, error, trackJson, track;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            FactoryCookie/* FactoryCookie.create */.f.create({
                                config: _this.config
                            }).cookie()
                        ];
                    case 1:
                        cookie = _state.sent();
                        ref = (0,_sliced_to_array/* default */.Z)(cookie.get({
                            key: CookieSharedRepository.COOKIE_TRACK,
                            encoding: "base64"
                        }), 2), error = ref[0], trackJson = ref[1];
                        if (!trackJson) return [
                            2,
                            Affiliate/* Affiliate.default */.Vv["default"]()
                        ];
                        if (error) return [
                            2,
                            Affiliate/* Affiliate.default */.Vv["default"]()
                        ];
                        try {
                            track = JSON.parse(trackJson);
                            if (!track.aid) return [
                                2,
                                Affiliate/* Affiliate.default */.Vv["default"]()
                            ];
                            return [
                                2,
                                Affiliate/* Affiliate.create */.Vv.create({
                                    value: track.aid,
                                    priceType: PriceType/* PriceType.createOrUndefinedFromCookie */.FT.createOrUndefinedFromCookie({
                                        value: track.rm
                                    })
                                })
                            ];
                        } catch (e) {
                            return [
                                2,
                                Affiliate/* Affiliate.default */.Vv["default"]()
                            ];
                        }
                        return [
                            2
                        ];
                }
            });
        })();
    };
    CookieSharedRepository.create = function create(param) {
        var config = param.config;
        return new CookieSharedRepository(config);
    };
    return CookieSharedRepository;
}(ForbiddenSharedRepository/* ForbiddenSharedRepository */.H);
CookieSharedRepository.MARKET_COOKIE_NAME = "sfl_mkt";
CookieSharedRepository.COOKIE_LANGUAGE = "lang";
CookieSharedRepository.COOKIE_TRACK = "track";

// EXTERNAL MODULE: ../../packages/stayforlong/src/_kernel/Environment.ts
var Environment = __webpack_require__(24880);
;// CONCATENATED MODULE: ../../packages/stayforlong/src/_domain/FactoryDomain.ts




var FactoryDomain = /*#__PURE__*/ function() {
    "use strict";
    function FactoryDomain(config) {
        (0,_class_call_check/* default */.Z)(this, FactoryDomain);
        this.config = config;
    }
    var _proto = FactoryDomain.prototype;
    _proto.domain = function domain() {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var isNode, _tmp;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        isNode = Environment/* Environment.create */.q.create().isNode();
                        if (!isNode) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            __webpack_require__.e(/* import() */ 808).then(__webpack_require__.t.bind(__webpack_require__, 10808, 23))
                        ];
                    case 1:
                        _tmp = _state.sent().NodeDomain.create({
                            config: _this.config
                        });
                        return [
                            3,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            __webpack_require__.e(/* import() */ 1939).then(__webpack_require__.bind(__webpack_require__, 11939))
                        ];
                    case 3:
                        _tmp = _state.sent().WindowDomain.create({
                            config: _this.config
                        });
                        _state.label = 4;
                    case 4:
                        return [
                            2,
                            _tmp
                        ];
                }
            });
        })();
    };
    FactoryDomain.create = function create(param) {
        var config = param.config;
        return new FactoryDomain(config);
    };
    return FactoryDomain;
}();

;// CONCATENATED MODULE: ../../packages/stayforlong/src/shared/infrastructure/DomainSharedRepository.ts









var DomainSharedRepository = /*#__PURE__*/ function(ForbiddenSharedRepository) {
    "use strict";
    (0,_inherits/* default */.Z)(DomainSharedRepository, ForbiddenSharedRepository);
    var _super = (0,_create_super/* default */.Z)(DomainSharedRepository);
    function DomainSharedRepository(config) {
        (0,_class_call_check/* default */.Z)(this, DomainSharedRepository);
        return _super.call(this, config);
    }
    var _proto = DomainSharedRepository.prototype;
    _proto.market = function market() {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var domain, ref, error, host;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            FactoryDomain.create({
                                config: _this.config
                            }).domain()
                        ];
                    case 1:
                        domain = _state.sent();
                        ref = (0,_sliced_to_array/* default */.Z)(domain.host(), 2), error = ref[0], host = ref[1];
                        if (error) return [
                            2,
                            Market/* Market.empty */.IY.empty()
                        ];
                        return [
                            2,
                            Market/* Market.fromHostName */.IY.fromHostName({
                                hostname: host
                            })
                        ];
                }
            });
        })();
    };
    DomainSharedRepository.create = function create(param) {
        var config = param.config;
        return new DomainSharedRepository(config);
    };
    return DomainSharedRepository;
}(ForbiddenSharedRepository/* ForbiddenSharedRepository */.H);

;// CONCATENATED MODULE: ../../packages/stayforlong/src/_headers/FactoryHeaders.ts




var FactoryHeader = /*#__PURE__*/ function() {
    "use strict";
    function FactoryHeader(config) {
        (0,_class_call_check/* default */.Z)(this, FactoryHeader);
        this.config = config;
    }
    var _proto = FactoryHeader.prototype;
    _proto.header = function header() {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var isNode, _tmp;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        isNode = Environment/* Environment.create */.q.create().isNode();
                        if (!isNode) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            __webpack_require__.e(/* import() */ 449).then(__webpack_require__.bind(__webpack_require__, 40449))
                        ];
                    case 1:
                        _tmp = _state.sent().NodeHeader.create({
                            config: _this.config
                        });
                        return [
                            3,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            __webpack_require__.e(/* import() */ 8816).then(__webpack_require__.bind(__webpack_require__, 38816))
                        ];
                    case 3:
                        _tmp = _state.sent().WindowHeader.create({
                            config: _this.config
                        });
                        _state.label = 4;
                    case 4:
                        return [
                            2,
                            _tmp
                        ];
                }
            });
        })();
    };
    FactoryHeader.create = function create(param) {
        var config = param.config;
        return new FactoryHeader(config);
    };
    return FactoryHeader;
}();

;// CONCATENATED MODULE: ../../packages/stayforlong/src/shared/infrastructure/HeaderSharedRepository.ts









var HeaderSharedRepository = /*#__PURE__*/ function(ForbiddenSharedRepository) {
    "use strict";
    (0,_inherits/* default */.Z)(HeaderSharedRepository, ForbiddenSharedRepository);
    var _super = (0,_create_super/* default */.Z)(HeaderSharedRepository);
    function HeaderSharedRepository(config) {
        (0,_class_call_check/* default */.Z)(this, HeaderSharedRepository);
        return _super.call(this, config);
    }
    var _proto = HeaderSharedRepository.prototype;
    _proto.language = function language() {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var header, ref, error, acceptedLanguage, locale;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            FactoryHeader.create({
                                config: _this.config
                            }).header()
                        ];
                    case 1:
                        header = _state.sent();
                        ref = (0,_sliced_to_array/* default */.Z)(header.getAcceptedLanguages(), 2), error = ref[0], acceptedLanguage = ref[1];
                        if (error) return [
                            2,
                            Language/* Language.empty */.S.empty()
                        ];
                        if (acceptedLanguage.localeWithRegion) {
                            locale = Language/* Language.createOrEmpty */.S.createOrEmpty({
                                value: acceptedLanguage.localeWithRegion.replace("-", "_")
                            });
                            if (!locale.isEmpty()) return [
                                2,
                                locale
                            ];
                        }
                        if (!acceptedLanguage.locale) return [
                            2,
                            Language/* Language.empty */.S.empty()
                        ];
                        return [
                            2,
                            Language/* Language.create */.S.create({
                                value: acceptedLanguage.locale
                            })
                        ];
                }
            });
        })();
    };
    HeaderSharedRepository.create = function create(param) {
        var config = param.config;
        return new HeaderSharedRepository(config);
    };
    return HeaderSharedRepository;
}(ForbiddenSharedRepository/* ForbiddenSharedRepository */.H);

// EXTERNAL MODULE: ../../packages/stayforlong/src/shared/infrastructure/QueryParamSharedRepository.ts + 1 modules
var QueryParamSharedRepository = __webpack_require__(86778);
;// CONCATENATED MODULE: ../../packages/stayforlong/src/shared/infrastructure/SharedRepositoryProxy.ts












var SharedRepositoryProxy = /*#__PURE__*/ function(ForbiddenSharedRepository) {
    "use strict";
    (0,_inherits/* default */.Z)(SharedRepositoryProxy, ForbiddenSharedRepository);
    var _super = (0,_create_super/* default */.Z)(SharedRepositoryProxy);
    function SharedRepositoryProxy(config, queryParamSharedRepository, cookieSharedRepository, domainSharedRepository, headerSharedRepository) {
        (0,_class_call_check/* default */.Z)(this, SharedRepositoryProxy);
        var _this;
        _this = _super.call(this, config);
        _this.queryParamSharedRepository = queryParamSharedRepository;
        _this.cookieSharedRepository = cookieSharedRepository;
        _this.domainSharedRepository = domainSharedRepository;
        _this.headerSharedRepository = headerSharedRepository;
        return _this;
    }
    var _proto = SharedRepositoryProxy.prototype;
    _proto.market = function market() {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var paramMarket, domainMarket, cookieMarket;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            _this.queryParamSharedRepository.market()
                        ];
                    case 1:
                        paramMarket = _state.sent();
                        if (!paramMarket.isEmpty()) return [
                            2,
                            paramMarket
                        ];
                        return [
                            4,
                            _this.domainSharedRepository.market()
                        ];
                    case 2:
                        domainMarket = _state.sent();
                        if (!domainMarket.isEmpty()) return [
                            2,
                            domainMarket
                        ];
                        return [
                            4,
                            _this.cookieSharedRepository.market()
                        ];
                    case 3:
                        cookieMarket = _state.sent();
                        if (!cookieMarket.isEmpty()) return [
                            2,
                            cookieMarket
                        ];
                        return [
                            2,
                            Market/* Market.default */.IY["default"]()
                        ];
                }
            });
        })();
    };
    _proto.language = function language() {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var paramLanguage, cookieLanguage, market, marketLanguage, headersLanguage;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            _this.queryParamSharedRepository.language()
                        ];
                    case 1:
                        paramLanguage = _state.sent();
                        if (!paramLanguage.isEmpty()) return [
                            2,
                            paramLanguage
                        ];
                        return [
                            4,
                            _this.cookieSharedRepository.language()
                        ];
                    case 2:
                        cookieLanguage = _state.sent();
                        if (!cookieLanguage.isEmpty()) return [
                            2,
                            cookieLanguage
                        ];
                        return [
                            4,
                            _this.market()
                        ];
                    case 3:
                        market = _state.sent();
                        marketLanguage = Language/* Language.fromMarket */.S.fromMarket(market.value);
                        if (!marketLanguage.isEmpty()) return [
                            2,
                            marketLanguage
                        ];
                        return [
                            4,
                            _this.headerSharedRepository.language()
                        ];
                    case 4:
                        headersLanguage = _state.sent();
                        if (!headersLanguage.isEmpty()) return [
                            2,
                            headersLanguage
                        ];
                        return [
                            2,
                            Language/* Language.default */.S["default"]()
                        ];
                }
            });
        })();
    };
    _proto.partialSearch = function partialSearch() {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                return [
                    2,
                    _this.queryParamSharedRepository.partialSearch()
                ];
            });
        })();
    };
    _proto.affiliate = function affiliate() {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                return [
                    2,
                    _this.cookieSharedRepository.affiliate()
                ];
            });
        })();
    };
    SharedRepositoryProxy.create = function create(param) {
        var config = param.config;
        return new SharedRepositoryProxy(config, QueryParamSharedRepository/* QueryParamSharedRepository.create */.K.create({
            config: config
        }), CookieSharedRepository.create({
            config: config
        }), DomainSharedRepository.create({
            config: config
        }), HeaderSharedRepository.create({
            config: config
        }));
    };
    return SharedRepositoryProxy;
}(ForbiddenSharedRepository/* ForbiddenSharedRepository */.H);


/***/ })

}]);